import { render, staticRenderFns } from "./DisputeLettersMenu.vue?vue&type=template&id=845e5bda&"
import script from "./DisputeLettersMenu.vue?vue&type=script&lang=js&"
export * from "./DisputeLettersMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports